import { render, staticRenderFns } from "./VerificationNumbers.vue?vue&type=template&id=219ed5a7&scoped=true&"
import script from "./VerificationNumbers.vue?vue&type=script&lang=js&"
export * from "./VerificationNumbers.vue?vue&type=script&lang=js&"
import style0 from "./VerificationNumbers.vue?vue&type=style&index=0&id=219ed5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ed5a7",
  null
  
)

export default component.exports